import React from 'react';
import Loadable from 'react-loadable';
import Loading from 'components/Loading';

const TestimonialCardLoadable = Loadable({
  loader: () => import('./TestimonialCard')
    .then(module => module.default)
    .catch(() => { if (window) window.location.reload(); }),
  loading: () => <div key="TestimonialCardLoadable"><Loading /></div>
});

export default TestimonialCardLoadable;
